import classNames from 'classnames';
import React from 'react';
import BsBadge from 'react-bootstrap/esm/Badge';
import './Badge.scss';

interface IBadgeProps {
  count?: number;
  className?: string;
}

export const Badge = ({ count, className }: IBadgeProps): JSX.Element|null => {
  if (count) {
    return <BsBadge className={classNames('zorro-badge', className)} variant="dark" pill>{ count }</BsBadge>;
  } else {
    return null;
  }
};
